<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <!-- ROW 1-->
    
    <div class="vx-row">
        <!-- CARD 6: Product Orders -->
        <div class="vx-col w-full lg:w-2/3 mb-base">
          <div class="vx-row">
            <div class="cursor-pointer vx-col w-full md:w-full xl:w-1/3" @click="allStudent(0)">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UsersIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( (student_dashboard ? student_dashboard.number_of_all_student_in_this_year  : '0') )"
                :statisticTitle="$t('Students')" />
            </div>

            <div class="cursor-pointer vx-col w-full md:w-full xl:w-1/3" @click="allStudent(1)">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserCheckIcon"
                icon-right
                :statisticTitle="$t('Girls')"
                :statistic="new Intl.NumberFormat('de-DE').format( (student_dashboard ? student_dashboard.number_of_all_girl_student_in_this_year  : '0') )"
                color="success" />
            </div>

            <div class="cursor-pointer vx-col w-full md:w-full xl:w-1/3" @click="allStudent(2)">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserPlusIcon"
                icon-right
                :statistic="new Intl.NumberFormat('de-DE').format( (student_dashboard ? student_dashboard.number_of_all_boy_student_in_this_year  : '0') )"
                :statisticTitle="$t('Boys')"
                color="warning" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="HeartIcon"
                  icon-right
                  statistic="26.8k"
                  statisticTitle="Favorited"
                  color="danger" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="SmileIcon"
                  icon-right
                  statistic="689"
                  statisticTitle="Reviews"
                  color="success" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="TruckIcon"
                  icon-right
                  statistic="2"
                  statisticTitle="Returns"
                  color="warning" />
            </div>
            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="EyeIcon"
                  icon-right
                statistic="36.9k"
                statisticTitle="Views" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="MessageSquareIcon"
                  icon-right
                statisticTitle="Comments"
                statistic="12k"
                color="success" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ShoppingBagIcon"
                  icon-right
                  statistic="978"
                  statisticTitle="Orders"
                  color="warning" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="HeartIcon"
                  icon-right
                  statistic="26.8k"
                  statisticTitle="Favorited"
                  color="danger" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="SmileIcon"
                  icon-right
                  statistic="689"
                  statisticTitle="Reviews"
                  color="success" />
            </div>

            <div class="vx-col w-full md:w-full xl:w-1/3" v-if="false">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="TruckIcon"
                  icon-right
                  statistic="2"
                  statisticTitle="Returns"
                  color="warning" />
            </div>
          </div>
        </div>
        <div
          class="vx-col w-full lg:w-1/3 mb-base"
          v-if="analyticsDataSee"
        >
          <vx-card :title="$t('Number_of_students')">
              <!-- CARD ACTION -->
              <!-- <template slot="actions">
                  <change-time-duration-dropdown />
              </template> -->

              <!-- Chart -->
              <div slot="no-body">
                  <vue-apex-charts type="pie" height="335" :options="analyticsData.productOrdersRadialBar.chartOptions" :series="productsOrder.series" />
              </div>

              <ul class="m-0 p-0">
                  <li @click="(orderData.orderType === 'Abandonment' ? abandonment(1) : abandonment(0))" v-for="orderData in productsOrder.analyticsData" :key="orderData.orderType" class="cursor-pointer flex justify-between py-2 px-3 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                      <span class="flex items-center">
                              <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid" :style="`border-color:${orderData.color}`"></span>
                              <span class="font-semibold">{{ $t(orderData.orderType) }}</span>
                      </span>
                      <span>{{ orderData.counts }}</span>
                  </li>
              </ul>
          </vx-card>
        </div>
    </div>

    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <statisticNiveaux :student_dashboard="student_dashboard"></statisticNiveaux>
      </div>
    </div>

  </div>
</template>

<script>
let base_self = ''

import statisticNiveaux from './statisticNiveaux.vue'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '@/views/ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'

export default {
  data () {
    return {
      student_dashboard : {},
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      salesRadar: {},

      timelineData: [
        {
          color: 'primary',
          icon: 'PlusIcon',
          title: 'Client Meeting',
          desc: 'Bonbon macaroon jelly beans gummi bears jelly lollipop apple',
          time: '25 mins Ago'
        },
        {
          color: 'warning',
          icon: 'MailIcon',
          title: 'Email Newsletter',
          desc: 'Cupcake gummi bears soufflé caramels candy',
          time: '15 Days Ago'
        },
        {
          color: 'danger',
          icon: 'UsersIcon',
          title: 'Plan Webinar',
          desc: 'Candy ice cream cake. Halvah gummi bears',
          time: '20 days ago'
        },
        {
          color: 'success',
          icon: 'LayoutIcon',
          title: 'Launch Website',
          desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.',
          time: '25 days ago'
        },
        {
          color: 'primary',
          icon: 'TvIcon',
          title: 'Marketing',
          desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.',
          time: '28 days ago'
        }
      ],


      analyticsData,
      analyticsDataSee: false,
      dispatchedOrders: []
    }
  },
  components: {
    statisticNiveaux,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  methods: {
    somme () {
      let sum = base_self.student_dashboard.nombre.number_of_all_student_in_this_year_no_abandonAtente
      sum += base_self.student_dashboard.nombre.number_of_all_abandonAtente_student_in_this_year
      sum += base_self.student_dashboard.nombre.number_of_all_abandon_student_in_this_year
      return sum
    },
    allStudent (id) {
      base_self.$router.push(`/Student_management/Student/main/${id}`).catch(() => {})
    },
    abandonment (id) {
      base_self.$router.push(`/Student_management/Abandonment/${id}`).catch(() => {})
    },
    initialise () {
      this.productsOrder = {
        analyticsData: [
          {
            color: '#7961F9',
            counts: base_self.student_dashboard.nombre.number_of_all_student_in_this_year_no_abandonAtente,
            orderType: 'In_good_standing'
          },
          {
            color: '#FF9F43',
            counts: base_self.student_dashboard.nombre.number_of_all_abandonAtente_student_in_this_year,
            orderType: 'Abandonment_pending'
          },
          {
            color: '#EA5455',
            counts: base_self.student_dashboard.nombre.number_of_all_abandon_student_in_this_year,
            orderType: 'Abandonment'
          }
        ],
        series: [
          Number(Number(base_self.student_dashboard.pourcentage.number_of_all_student_in_this_year_no_abandonAtente_pourcentage).toFixed(2)),
          Number(Number(base_self.student_dashboard.pourcentage.number_of_all_abandonAtente_student_in_this_year_pourcentage).toFixed(2)),
          Number(Number(base_self.student_dashboard.pourcentage.number_of_all_abandon_student_in_this_year_pourcentage).toFixed(2))
        ]
      }

      base_self.analyticsData.productOrdersRadialBar.chartOptions.colors = ['#7961F9', '#FF9F43', '#EA5455']
      base_self.analyticsData.productOrdersRadialBar.chartOptions.labels = ['En règle', 'Abandon en attente', 'Abandon']
      base_self.analyticsData.productOrdersRadialBar.chartOptions.plotOptions.radialBar.dataLabels.total.label = 'Total'

      base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))

      setTimeout(
        function () { 
          base_self.analyticsData.productOrdersRadialBar.chartOptions.labels = [base_self.$t('In_good_standing'), base_self.$t('Abandonment_pending'), base_self.$t('Abandonment')]
          base_self.analyticsData.productOrdersRadialBar.chartOptions.plotOptions.radialBar.dataLabels.total.label = base_self.$t('Total')
          base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))

          base_self.analyticsDataSee = true
        }, 1000)

    },
    async studentDashboard () {
      base_self.$vs.loading()
      base_self.$http.get(`${base_self.$store.state.route_for_esm}student-dashboard`)
        .then((response) => {
          base_self.student_dashboard = response.data.data.student_dashboard
          console.log('base_self.student_dashboard: ', base_self.student_dashboard)
          base_self.initialise()
          base_self.$vs.loading.close()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
    }
  },
  created () {
    base_self = this
    window.dashboardStudent = this
    // http://localhost:8050/api/base/student-dashboard
    base_self.studentDashboard()

    //  User Reward Card
    this.$http.get('/api/user/checkpoint-reward')
      .then((response) => { this.checkpointReward = response.data })
      .catch((error)   => { console.log(error) })

      // Subscribers gained - Statistics
    this.$http.get('/api/card/card-statistics/subscribers')
      .then((response) => { this.subscribersGained = response.data })
      .catch((error)   => { console.log(error) })

      // Orders - Statistics
    this.$http.get('/api/card/card-statistics/orders')
      .then((response) => { this.ordersRecevied = response.data })
      .catch((error)   => { console.log(error) })

      // Sales bar - Analytics
    this.$http.get('/api/card/card-analytics/sales/bar')
      .then((response) => { this.salesBarSession = response.data })
      .catch((error)   => { console.log(error) })

      // Support Tracker
    this.$http.get('/api/card/card-analytics/support-tracker')
      .then((response) => { this.supportTracker = response.data })
      .catch((error)   => { console.log(error) })

      // Products Order
    /* this.$http.get('/api/card/card-analytics/products-orders')
      .then((response) => { 
        // this.productsOrder = response.data 
        

        // console.log('this.productsOrder: ', this.productsOrder)
      })
      .catch((error)   => { console.log(error) }) */

      // Sales Radar
    this.$http.get('/api/card/card-analytics/sales/radar')
      .then((response) => { this.salesRadar = response.data })
      .catch((error)   => { console.log(error) })

      // Dispatched Orders
    this.$http.get('/api/table/dispatched-orders')
      .then((response) => { this.dispatchedOrders = response.data })
      .catch((error)   => { console.log(error) })
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
